import { __exports as rangePrice } from './_virtual-rangePrice2.js';
import { __require as requireEs_string_replace } from './node_modules-core-js-modules-es.string.replace.js';
import { __require as requireContainer } from './vp-js-token-engine-build-infrastructure-container.js';
import { __require as requireVatHelper } from './vp-js-token-engine-build-common-vatHelper.js';
import { __require as requireLocalizations } from './vp-js-token-engine-build-infrastructure-localizations.js';

var hasRequiredRangePrice;

function requireRangePrice () {
	if (hasRequiredRangePrice) return rangePrice;
	hasRequiredRangePrice = 1;

	Object.defineProperty(rangePrice, "__esModule", {
	  value: true
	});
	rangePrice.filter = filter;
	rangePrice.name = void 0;
	requireEs_string_replace();
	var _container = requireContainer();
	var _vatHelper = requireVatHelper();
	var _localizations = requireLocalizations();
	const name = rangePrice.name = 'rangePrice';
	const RANGE_LIST_PRICE_TEMPLATE = "<span class='swan-list-price'>{{lowestListPrice}} — {{highestListPrice}}</span>";
	const COMPARATIVE_RANGE_PRICE_TEMPLATE = "<span class='swan-pricing-comparison'><span class='list-price-wrapper' aria-hidden='true'><span class='swan-list-price'><span class='swan-visually-hidden'>{{originalPrice}}</span>{{lowestListPrice}}</span> — <span class='swan-list-price'>{{highestListPrice}}</span></span> <span class='swan-discount-price'><span class='swan-visually-hidden'>{{salePrice}}</span>{{lowestDiscountPrice}} — {{highestDiscountPrice}}</span></span>";
	async function filter(lowestListPrice, highestListPrice, lowestDiscountPrice, highestDiscountPrice, currency, minimumFractionDigits, vatInc, hideVatMessage, hideShippingMessageInVatMessage) {
	  const scope = this;
	  const culture = _container.contextService.getCulture(scope);
	  const htmlTemplates = {};
	  const mustacheVariables = {};
	  let formattedLowestDiscountedPrice;
	  let formattedHighestDiscountedPrice;
	  if (lowestListPrice !== lowestDiscountPrice || highestListPrice !== highestDiscountPrice) {
	    htmlTemplates['comparativeRangePriceListDiscount'] = COMPARATIVE_RANGE_PRICE_TEMPLATE;
	    formattedLowestDiscountedPrice = _container.formatterService.formatPrice({
	      culture,
	      currency,
	      price: lowestDiscountPrice,
	      minimumFractionDigits
	    });
	    formattedHighestDiscountedPrice = _container.formatterService.formatPrice({
	      culture,
	      currency,
	      price: highestDiscountPrice,
	      minimumFractionDigits
	    });
	    mustacheVariables['originalPrice'] = (0, _localizations.localized)('originalPrice', culture);
	    mustacheVariables['salePrice'] = (0, _localizations.localized)('salePrice', culture);
	  } else {
	    htmlTemplates['comparativeRangePriceListDiscount'] = RANGE_LIST_PRICE_TEMPLATE;
	  }
	  const formattedLowestListPrice = _container.formatterService.formatPrice({
	    culture,
	    currency,
	    price: lowestListPrice,
	    minimumFractionDigits
	  });
	  const formattedHighestListPrice = _container.formatterService.formatPrice({
	    culture,
	    currency,
	    price: highestListPrice,
	    minimumFractionDigits
	  });
	  mustacheVariables['lowestListPrice'] = formattedLowestListPrice;
	  mustacheVariables['highestListPrice'] = formattedHighestListPrice;
	  mustacheVariables['lowestDiscountPrice'] = formattedLowestDiscountedPrice;
	  mustacheVariables['highestDiscountPrice'] = formattedHighestDiscountedPrice;
	  mustacheVariables['vatInc'] = vatInc;
	  if (!hideVatMessage) {
	    mustacheVariables['vatMessage'] = await (0, _vatHelper.getVatHtml)(vatInc, culture, hideShippingMessageInVatMessage, scope);
	  }
	  const template = (0, _localizations.localized)(name, culture);
	  return _container.mustacheService.replace(template, mustacheVariables, htmlTemplates);
	}
	
	return rangePrice;
}

export { requireRangePrice as __require };
//# sourceMappingURL=vp-js-token-engine-build-filters-rangePrice.js.map
